/*
 * utils.quasar.notify.ts
 */
import { Notify } from 'quasar';
import type { mtAxiosReturn } from 'src/config/config.type.axios';
//
export class mcUtilsQuasarNotify {
  public cpifNotifyPositive(psMessage: string): void {
    // $q.notify({
    //   color: 'positive',
    //   message: psMessage,
    // })
    Notify.create({
      color: 'positive',
      icon: 'info',
      message: psMessage,
    });
  }
  //
  public cpifNotifyNegative(psMessage: string): void {
    Notify.create({
      color: 'negative',
      icon: 'warning',
      message: psMessage,
      timeout: 10000, // 20250820: Increase to 10 seconds (default is 5 seconds)!
    });
  }
  //
  public cpifNotifyInfo(psMessage: string, pnTimeout: number = 5000): void {
    Notify.create({
      color: 'deep-purple',
      message: psMessage,
      timeout: pnTimeout,
      type: 'info',
    });
  }
  //
  public cpifNotify(poReturn: mtAxiosReturn): void {
    if (true === poReturn.cpibIsError) {
      this.cpifNotifyNegative(poReturn.cpisMessage);
    } else {
      this.cpifNotifyPositive(poReturn.cpisMessage);
    }
  }
  //
  public cpifNotifyIfError(poReturn: mtAxiosReturn): void {
    if (true === poReturn.cpibIsError) {
      this.cpifNotifyNegative(poReturn.cpisMessage);
    }
  }
}
//#end#
